import { setPendingChangesAuthorsHeaderValue } from 'app/services/http/pendingChangesAuthorsHeader';

import { selectPendingChangesAuthorsHeaderValue } from '../selectors/pendingChangesAuthorsSelection.selectors';

// Syncs right after the reducer runs, so a reload dispatched in the same handler as a selection
// change already carries the new header.
const pendingChangesAuthorsHeaderMiddleware =
  ({ getState }) =>
  next =>
  action => {
    const result = next(action);

    setPendingChangesAuthorsHeaderValue(selectPendingChangesAuthorsHeaderValue(getState()));

    return result;
  };

export default pendingChangesAuthorsHeaderMiddleware;
